import { useState, useEffect, useRef } from "react";
import useTranslationSetup from "../utils/useTranslationSetup";
import {
  SCREENS,
  shikshakInstructionContent,
} from "../utils/CommonUtils/constants";
import VopaInstructionScreen from "../screens/VopaInstructionScreen/VopaInstructionScreen";
import CohortMainScreen from "../screens/CohortMainScreen/CohortMainScreen";
import useParamValues from "../utils/useParamValues";
import fetchStudentsListBySchoolId from "../fetchApi/fetchStudentsListByTeacherId";
import LoadingWrapper from "../components/LoadingWrapper/LoadingWrapper";
import CustomErrorDialogBox from "../components/CustomErrorDialogBox/CustomErrorDialogBox";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutline";
import * as Sentry from "@sentry/browser";
import { UrlConstants } from "../utils/CommonUtils/constants";
const CohortFlow = () => {
  const { t } = useTranslationSetup();
  const [activeScreen, setActiveScreen] = useState(
    SCREENS.RENDER_INSTRUCTIONS_SCREEN
  );
  const abortController = useRef(null);
  const [students, setStudents] = useState([]);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const { token, studentIds, classNum } = useParamValues();
  const studentListUrl = `${UrlConstants.BASE_URL}${UrlConstants.BASE_PATH_URL}student?student_ids=${studentIds}&grade=${classNum}`;

  const handleFetchStudents = async () => {
    try {
      const response = await fetchStudentsListBySchoolId(
        studentListUrl,
        abortController,
        token
      );
      if (response.status === "ERROR") {
        setErrorDialogOpen(true);
      } else {
        setStudents(response.students);
        setActiveScreen(SCREENS.RENDER_COHORT_VIEW_SCREEN);
      }
    } catch (err) {
      setErrorDialogOpen(true);
      Sentry.captureException(err);
    }
  };

  const handleRetryClick = () => {
    setErrorDialogOpen(false);
    setActiveScreen(SCREENS.RENDER_COHORT_LOADING_SCREEN);
    handleFetchStudents();
  };

  const handleInstructionsComplete = () => {
    setActiveScreen(SCREENS.RENDER_COHORT_LOADING_SCREEN);
    handleFetchStudents();
  };

  const renderActiveScreen = () => {
    switch (activeScreen) {
      case SCREENS.RENDER_INSTRUCTIONS_SCREEN:
        return (
          <VopaInstructionScreen
            instructionContent={shikshakInstructionContent(t, "cohort")}
            setActiveScreen={() => {
              sessionStorage.setItem(
                "activeScreen",
                SCREENS.RENDER_COHORT_VIEW_SCREEN
              );
              handleInstructionsComplete();
            }}
          />
        );

      case SCREENS.RENDER_COHORT_LOADING_SCREEN:
        return (
          <>
            <LoadingWrapper type="isLoading" />
            <CustomErrorDialogBox
              header={t("something_went_wrong")}
              icon={
                <ErrorOutlineOutlinedIcon
                  style={{
                    color: "#D95959",
                    borderRadius: "10px",
                    marginTop: "16px",
                    width: "80px",
                    height: "80px",
                  }}
                />
              }
              primaryButtonText={t("try_again")}
              isDialogOpen={errorDialogOpen}
              showPrimaryButton
              onClickPrimaryButton={handleRetryClick}
            />
          </>
        );

      case SCREENS.RENDER_COHORT_VIEW_SCREEN:
        return (
          <CohortMainScreen
            students={students}
            setActiveScreen={setActiveScreen}
          />
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    if (
      sessionStorage.getItem("activeScreen") ===
      SCREENS.RENDER_COHORT_VIEW_SCREEN
    ) {
      handleInstructionsComplete();
    }
  }, []);

  return <>{renderActiveScreen()}</>;
};

export default CohortFlow;
